const messages = {
  'preCall.close': { en: 'Close', fr: 'Fermer' },
  'preCall.permission.title': {
    en: "Let's check your session settings",
    fr: 'Vérifions les paramètres de votre séance',
  },
  'preCall.permission.description': {
    en: 'Your browser will ask for camera and microphone access. You need to allow both before joining your session.',
    fr: 'Votre navigateur demandera l’accès à votre caméra et à votre microphone. Vous devez autoriser les deux avant de rejoindre votre séance.',
  },
  'preCall.permission.microphone.title': {
    en: 'Allow microphone',
    fr: 'Autoriser le microphone',
  },
  'preCall.permission.microphone.description': {
    en: 'So your care provider can hear you',
    fr: 'Pour que votre prestataire de soins puisse vous entendre',
  },
  'preCall.permission.camera.title': {
    en: 'Allow camera',
    fr: 'Autoriser la caméra',
  },
  'preCall.permission.camera.description': {
    en: 'So your care provider can see you',
    fr: 'Pour que votre prestataire de soins puisse vous voir',
  },
  'preCall.permission.continue': { en: 'Continue', fr: 'Continuer' },
  'preCall.permission.practitionerContinue': { en: 'Close', fr: 'Fermer' },
  'preCall.microphoneRequired.title': {
    en: 'Microphone required to join',
    fr: 'Un microphone est requis pour participer',
  },
  'preCall.microphoneRequired.description': {
    en: "You can't join your appointment until microphone access is enabled in your browser settings. You might see a pop-up notification or an icon in your address bar asking you to allow access.",
    fr: 'Vous ne pouvez pas rejoindre votre rendez-vous tant que l’accès au microphone n’est pas activé dans les paramètres de votre navigateur.',
  },
  'preCall.microphoneRequired.camera': {
    en: 'Camera access is optional but recommended. You can turn it on or off at any time during your session.',
    fr: 'L’accès à la caméra est facultatif, mais recommandé. Vous pouvez l’activer ou la désactiver à tout moment pendant votre séance.',
  },
  'preCall.microphoneRequired.close': { en: 'Close', fr: 'Fermer' },
  'preCall.practitionerRequired.title': {
    en: 'Microphone and camera required to join',
    fr: 'Un microphone et une caméra sont requis pour participer',
  },
  'preCall.practitionerRequired.description': {
    en: "You can't join your appointment until microphone and camera access are enabled in your browser settings. You might see a pop-up notification or an icon in your address bar asking you to allow access.",
    fr: 'Vous ne pouvez pas rejoindre votre rendez-vous tant que l’accès au microphone et à la caméra n’est pas activé dans les paramètres de votre navigateur. Une notification contextuelle ou une icône dans votre barre d’adresse pourrait vous demander d’autoriser l’accès.',
  },
  'preCall.title': {
    en: 'You are about to start your session',
    fr: 'Vous êtes sur le point de commencer votre séance',
  },
  'preCall.description': {
    en: "Before you join, make sure you're in a comfortable and quiet space.",
    fr: 'Avant de participer, assurez-vous d’être dans un endroit confortable et calme.',
  },
  'preCall.practitionerDescription': {
    en: 'Please ensure that you are in a comfortable and quiet space before you start.',
    fr: 'Veuillez vous assurer d’être dans un endroit confortable et calme avant de commencer.',
  },
  'preCall.cameraPreview': { en: 'Camera preview', fr: 'Aperçu de la caméra' },
  'preCall.turnOff': { en: 'Turn Off', fr: 'Désactiver' },
  'preCall.turnOn': { en: 'Turn On', fr: 'Activer' },
  'preCall.camera.label': { en: 'Camera', fr: 'Caméra' },
  'preCall.camera.ready': {
    en: 'Camera is working properly',
    fr: 'La caméra fonctionne correctement',
  },
  'preCall.camera.requesting': {
    en: 'Checking camera...',
    fr: 'Vérification de la caméra...',
  },
  'preCall.camera.missing': {
    en: 'No camera found',
    fr: 'Aucune caméra trouvée',
  },
  'preCall.camera.blocked': {
    en: 'Camera access is blocked',
    fr: 'L’accès à la caméra est bloqué',
  },
  'preCall.camera.failed': {
    en: 'Camera is unavailable',
    fr: 'La caméra n’est pas disponible',
  },
  'preCall.microphone.label': { en: 'Microphone', fr: 'Microphone' },
  'preCall.microphone.ready': {
    en: 'Microphone is working properly',
    fr: 'Le microphone fonctionne correctement',
  },
  'preCall.microphone.requesting': {
    en: 'Checking microphone...',
    fr: 'Vérification du microphone...',
  },
  'preCall.microphone.missing': {
    en: 'No microphone found',
    fr: 'Aucun microphone trouvé',
  },
  'preCall.microphone.blocked': {
    en: 'Microphone access is blocked',
    fr: 'L’accès au microphone est bloqué',
  },
  'preCall.microphone.failed': {
    en: 'Microphone is unavailable',
    fr: 'Le microphone n’est pas disponible',
  },
  'preCall.microphoneAccessNeeded.title': {
    en: 'Microphone access needed',
    fr: 'Accès au microphone requis',
  },
  'preCall.microphoneAccessNeeded.description': {
    en: 'Go to your browser settings to allow access to your microphone.',
    fr: 'Accédez aux paramètres de votre navigateur pour autoriser l’accès à votre microphone.',
  },
  'preCall.speaker.label': { en: 'Speaker', fr: 'Haut-parleur' },
  'preCall.speaker.unsupported': {
    en: 'Speaker selection is not supported in this browser.',
    fr: 'La sélection du haut-parleur n’est pas prise en charge par ce navigateur.',
  },
  'preCall.speaker.playing': {
    en: 'Playing test sound...',
    fr: 'Lecture du son de test...',
  },
  'preCall.speaker.help': {
    en: 'Select a speaker and test the sound.',
    fr: 'Sélectionnez un haut-parleur et testez le son.',
  },
  'preCall.speaker.test': { en: 'Play test sound', fr: 'Tester le son' },
  'preCall.technicalIssues.title': {
    en: "If you're having technical issues",
    fr: 'Si vous éprouvez des difficultés techniques',
  },
  'preCall.technicalIssues.description': {
    en: 'Dial {{tollFree}} and enter the PIN {{pin}} followed by the # key.',
    fr: 'Composez le {{tollFree}} et entrez le NIP {{pin}}, suivi de la touche #.',
  },
  'preCall.cancel': { en: 'Cancel', fr: 'Annuler' },
  'preCall.join': { en: 'Join Session', fr: 'Rejoindre la séance' },
  'deviceSettings.joinTollFree.before': {
    en: 'Alternatively, join via Toll-free number ',
    fr: 'Vous pouvez également vous connecter en utilisant le numéro sans frais ',
  },
  'deviceSettings.joinTollFree.after': {
    en: ' and use pin {{pin}} followed by #',
    fr: ' et en composant le code NIP {{pin}} suivi du carré (#)',
  },
  'deviceSettings.camera.rejoin': {
    en: 'Reconnect the session to start using a camera.',
    fr: 'Reconnectez la séance pour commencer à utiliser une caméra.',
  },
  'deviceSettings.camera.error': {
    en: 'Unable to change camera. Your previous camera is still selected.',
    fr: 'Impossible de changer de caméra. La caméra précédente est toujours sélectionnée.',
  },
  'deviceSettings.camera.changing': {
    en: 'Changing camera...',
    fr: 'Changement de caméra...',
  },
  'deviceSettings.microphone.error': {
    en: 'Unable to change microphone. Your previous microphone is still selected.',
    fr: 'Impossible de changer de microphone. Le microphone précédent est toujours sélectionné.',
  },
  'deviceSettings.microphone.changing': {
    en: 'Changing microphone...',
    fr: 'Changement de microphone...',
  },
  'deviceSettings.speaker.error': {
    en: 'Unable to change speaker. Your previous speaker is still selected.',
    fr: 'Impossible de changer de haut-parleur. Le haut-parleur précédent est toujours sélectionné.',
  },
  'deviceSettings.speaker.changing': {
    en: 'Changing speaker...',
    fr: 'Changement de haut-parleur...',
  },
  'liveCaptions.label': { en: 'Captions', fr: 'Sous-titrage' },
  'liveCaptions.toggleLabel': { en: 'Captions', fr: 'Sous-titrage' },
  'liveCaptions.description': {
    en: 'Provides real-time transcription of what other people are saying during the session. Translations are not available.',
    fr: 'Transcrit en temps réel ce qui est dit par les autres personnes durant la séance. La traduction n’est pas disponible.',
  },
  'liveCaptions.panelTitle': {
    en: 'Live Captions',
    fr: 'Sous-titrage instantané',
  },
  'liveCaptions.panelDescription': {
    en: 'Captions are system-generated and may not be 100% accurate.',
    fr: 'Les sous-titres sont générés automatiquement et pourraient ne pas être toujours exacts.',
  },
  'liveCaptions.jumpToNewest': {
    en: 'Jump to newest',
    fr: 'Aller au plus récent',
  },
  'liveCaptions.enable': {
    en: 'Enable captions',
    fr: 'Activer le sous-titrage',
  },
  'liveCaptions.disable': {
    en: 'Disable captions',
    fr: 'Désactiver le sous-titrage',
  },
  'liveCaptions.phoneSpeaker': {
    en: 'Phone call •••• {{last4}}',
    fr: 'Appel téléphonique •••• {{last4}}',
  },
  'liveCaptions.phoneSpeakerPending': {
    en: 'Phone call',
    fr: 'Appel téléphonique',
  },
  'liveCaptions.phoneSpeakerUnknown': {
    en: 'Unknown phone caller',
    fr: 'Appelant téléphonique inconnu',
  },
};

export const sharedDeviceMessage = (id, locale = 'en', values = {}) => {
  const found = messages[id];
  if (!found) return undefined;
  return Object.keys(values).reduce(
    (message, key) => message.replace(`{{${key}}}`, values[key]),
    found[locale] || found.en,
  );
};

export default messages;
